import type { CalendarPeriod } from '@liks/lac-svc-api/esm/models/index';
import { useQuery } from '@tanstack/react-query';
import { lacAnalyticsService } from '../../../services/LacAnalyticsService';
import { lacQueryKeys } from '../lacQueryKeys';

type UseLacCrawlJobTimeSeriesQueryOptions = {
  /** Omit to load counts for all tenants. */
  tenantName?: string;
  groupBy: CalendarPeriod;
  fromDate: string;
  toDate: string;
  enabled?: boolean;
};

export function useLacCrawlJobTimeSeriesQuery({
  tenantName,
  groupBy,
  fromDate,
  toDate,
  enabled = true,
}: UseLacCrawlJobTimeSeriesQueryOptions) {
  const trimmedTenantName = tenantName?.trim() ?? '';
  const scopedTenantName = trimmedTenantName === '' ? null : trimmedTenantName;

  return useQuery({
    queryKey: lacQueryKeys.crawlJobTimeSeries(
      scopedTenantName,
      groupBy,
      fromDate,
      toDate,
    ),
    enabled: enabled && fromDate.length > 0 && toDate.length > 0,
    queryFn: () =>
      lacAnalyticsService.getCrawlJobTimeSeries({
        tenantName: scopedTenantName ?? undefined,
        groupBy,
        fromDate,
        toDate,
      }),
  });
}
